import {CATEGORY_ORDER} from '@redstack/shared'
import {createFileRoute, redirect} from '@tanstack/react-router'
import {zodValidator} from '@tanstack/zod-adapter'
import {z} from 'zod'

// Legacy schema kept so old /permits?... URLs validate before redirect.
// Once nothing links here, this route can be deleted entirely.
const legacyPermitsSearchSchema = z.object({
	regions: z.array(z.string()).default([]),
	page: z.number().min(1).default(1),
	pageSize: z.number().min(1).max(500).default(50),
	status: z.enum(CATEGORY_ORDER).optional(),
	assignedTo: z.string().optional(),
	search: z.string().optional(),
	contractorKey: z.string().optional(),
	contractorLabel: z.string().optional(),
	// No issueDateFrom/issueDateTo: the free date filter was removed and the
	// board schema no longer declares them. Leaving them here would let the
	// `...rest` spread below re-inject dead params into the redirect target.
})

type LegacyPermitsSearch = z.output<typeof legacyPermitsSearchSchema>

// Re-exports kept so any straggling imports of `PermitsSearch` / `defaultPermitsSearch`
// still compile during the consolidation. Prefer importing from /routes/board/index.
export type PermitsSearch = LegacyPermitsSearch
export const defaultPermitsSearch: PermitsSearch = {
	regions: [],
	page: 1,
	pageSize: 50,
	status: undefined,
	assignedTo: undefined,
	search: undefined,
	contractorKey: undefined,
	contractorLabel: undefined,
}

export const Route = createFileRoute('/permits/')({
	validateSearch: zodValidator(legacyPermitsSearchSchema),
	beforeLoad: ({search}) => {
		// Board models status/assignedTo as arrays; lift the legacy single values
		// into arrays so old `/permits?status=DONE&assignedTo=…` bookmarks survive.
		const {status, assignedTo, ...rest} = search
		throw redirect({
			to: '/board',
			search: {
				...rest,
				status: status ? [status] : [],
				assignedTo: assignedTo ? [assignedTo] : [],
				view: 'list' as const,
			},
		})
	},
})
